/* eslint-disable */
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Button, Box, CircularProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';
// hooks
import { useQueryVerifyUserEmail } from '../../hooks/react-query/useData';

// components
import Logo from '../../components/logo';

const StyledContent = styled('div')(({ theme }) => ({
  margin: 'auto',
  marginTop: 0,
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(3, 2),
  paddingTop: theme.spacing(10),
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : 'rgba(0, 0, 0, 0.04)',
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const [apiResponse, setApiResponse] = useState();
  const navigate = useNavigate();

  const onSuccess = (success) => {
    // toast.success(success?.data?.message, { duration: 10000 });

    if (success.data.message.includes('Account Verified Successfully')) {
      setApiResponse('success');
      return;
    }

    toast.success(success?.response?.data?.message, { duration: 5000 });
  };
  const onError = (error) => {
    if (error?.message === 'Network Error') {
      setApiResponse('Server Error');
      return;
    }
    setApiResponse(error?.response?.data?.message);
  };


  const { isLoading } = useQueryVerifyUserEmail(
    {
      token: searchParams.get('token'), // 10
    },
    onSuccess,
    onError
  );
  return (
    <Box
      sx={{
        minHeight: '100vh',
        minWidth: '100%',
        bgcolor: 'background.default',
      }}
    >
      <Logo
        sx={{
          position: 'fixed',
          width: '100%',
          justifyContent: 'center',
          bgcolor: 'background.paper',
          p: '18px 0 12px 0',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      />

      <StyledContent>
        {apiResponse === 'success' && (
          <Box
            sx={{
              width: '100%',
              maxWidth: 520,
              boxShadow: (theme) =>
                theme.palette.mode === 'dark'
                  ? `0px 8px 32px ${alpha(theme.palette.common.black, 0.48)}`
                  : '0px 8px 24px rgba(13, 10, 44, 0.08)',
              borderRadius: 3,
              mx: 'auto',
              bgcolor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 4,
              px: 3,
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark'
                    ? alpha(theme.palette.primary.main, 0.16)
                    : alpha(theme.palette.primary.main, 0.08),
                mb: 2,
              }}
            >
              <Box
                component="img"
                src="/assets/illustrations/emailVerifiedCheck.svg"
                alt=""
                sx={{ width: 48, height: 48 }}
              />
            </Box>

            <Typography
              variant="h4"
              sx={{
                textAlign: 'center',
                color: 'text.titles',
                fontWeight: 700,
                mb: 1,
              }}
            >
              Email Verified
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                lineHeight: 1.6,
                maxWidth: 360,
                mb: 3,
              }}
            >
              Thank you! Your email has been verified. Your account is now active.
            </Typography>

            <Button
              variant="contained"
              color="main"
              onClick={() => navigate('/login')}
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 2,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: (theme) =>
                  theme.palette.mode === 'dark'
                    ? `0px 4px 14px ${alpha(theme.palette.primary.main, 0.4)}`
                    : undefined,
              }}
            >
              Login to Your Account
            </Button>

            <Typography
              variant="body2"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                mt: 4,
              }}
            >
              Thank you for choosing Edifying Teachers!
            </Typography>
          </Box>
        )}
        {isLoading && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              py: 6,
              px: 3,
              borderRadius: 3,
              bgcolor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
              maxWidth: 400,
            }}
          >
            <CircularProgress size={32} />
            <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 500 }}>
              Verifying your email...
            </Typography>
          </Box>
        )}
        {!isLoading && apiResponse && apiResponse !== 'success' && (
          <Box
            sx={{
              textAlign: 'center',
              py: 4,
              px: 3,
              borderRadius: 3,
              bgcolor: 'background.paper',
              border: '1px solid',
              borderColor: 'error.main',
              maxWidth: 440,
            }}
          >
            <Typography variant="body1" sx={{ color: 'error.main' }}>
              {apiResponse}
            </Typography>
          </Box>
        )}
      </StyledContent>
    </Box>
  );
}
